<template>
  <div
    class="fm-ctx"
    :style="{ top: y + 'px', left: x + 'px' }"
    v-click-outside="() => $emit('close')"
  >
    <button class="fm-ctx-item" @click="$emit('rename', item)" :disabled="!canRename">
			<v-icon size="18" color="currentColor">mdi-pencil-outline</v-icon>
      Renombrar
    </button>
    <button class="fm-ctx-item" @click="$emit('move')" :disabled="!canMove">
			<v-icon size="18" color="currentColor">mdi-folder-move-outline</v-icon>
      Mover a...
    </button>
    <button class="fm-ctx-item" @click="$emit('download', item)">
      <v-icon size="18" color="currentColor">mdi-download</v-icon>
      Descargar
    </button>
    <button v-if="isFile" class="fm-ctx-item" @click="$emit('activity', item)">
      <v-icon size="18" color="currentColor">mdi-history</v-icon>
      Ver actividad
    </button>
    <button class="fm-ctx-item" @click="$emit('open-morphable', item)" v-if="openMorphableText">
      <v-icon size="18" color="currentColor">{{ openMorphableIcon }}</v-icon>
      {{ openMorphableText }}
    </button>
    <button class="fm-ctx-item" @click="$emit('open', item)" v-if="item.pathdoc">
      <v-icon size="18" color="currentColor">mdi-open-in-new</v-icon>
      Abrir en nueva ventana
    </button>
    <button class="fm-ctx-item" @click="$emit('add-revision', item)" v-if="isFile && !item.folder && !isReference">
      <v-icon size="18" color="currentColor">mdi-file-plus-outline</v-icon>
      Agregar nueva revisión
    </button>
    <button class="fm-ctx-item" @click="$emit('to-forge', item)"
      v-if="showSendToForge"
      :disabled="!canSendToForge"
      :style="item.forge_file?.processing ? { opacity: 0.6, pointerEvents: 'none' } : {}">
			<div class="d-flex align-center" style="gap:10px;" v-if="item.forge_file?.processing">
				<v-icon size="18" color="currentColor">mdi-floor-plan</v-icon>
				Procesando para Visor Autodesk
			</div>
			<div class="d-flex align-center" style="gap:10px;" v-else>
				<v-icon size="18" color="currentColor">mdi-floor-plan</v-icon>
				Enviar a Visor Autodesk
			</div>
    </button>
    <button class="fm-ctx-item" @click="$emit('view-in-forge', item)"
			v-if="showViewInForge">
      <v-icon size="18" color="currentColor">mdi-floor-plan</v-icon>
      Ver en Visor Autodesk
    </button>
    <button class="fm-ctx-item" @click="$emit('open', item)"
			v-if="showViewInForge">
      <v-icon size="18" color="currentColor">mdi-floor-plan</v-icon>
      Nueva Pestaña Visor Autodesk
    </button>
    <div class="fm-ctx-sep"></div>
    <button class="fm-ctx-item fm-ctx-warning" @click="$emit('restore')" :disabled="!canRestore" v-if="item.deleted_at">
      <v-icon size="18" color="currentColor">mdi-delete-restore</v-icon>
      Restaurar{{ selectedCount > 1 ? ' (' + selectedCount + ')' : '' }}
    </button>
    <button class="fm-ctx-item fm-ctx-danger" @click="$emit('delete')" :disabled="!canDelete" v-else>
      <v-icon size="18" color="currentColor">mdi-delete-outline</v-icon>
      Eliminar{{ selectedCount > 1 ? ' (' + selectedCount + ')' : '' }}
    </button>
  </div>
</template>

<script>
import { checkPermissions } from '@/helpers/permissions'
import { isForgeItem, isForgeTranslated } from '@/helpers/forge'

export default {
  name: 'FMContextMenu',
  props: { x: Number, y: Number, item: Object, selectedCount: Number, forgeSupportedExtensions: Array },
	computed: {
		isFile() {
			return this.item && this.item.type !== 'folder'
		},
		showSendToForge() {
    return !this.isReference && isForgeItem(this.item, this.forgeSupportedExtensions || []) && !isForgeTranslated(this.item)
		},
		showViewInForge() {
      return isForgeItem(this.item, this.forgeSupportedExtensions || []) && isForgeTranslated(this.item)
		},
		canRename() {
      return !this.isReference && checkPermissions(['rename_files'])
		},
		canMove() {
      return !this.isReference && checkPermissions(['move_files'])
		},
		canDelete() {
      return !this.isReference && checkPermissions(['delete_files', 'delete_folders'])
		},
		canRestore() {
      return !this.isReference && checkPermissions(['restore_files', 'restore_folders'])
		},
    isReference() {
      return Boolean(this.item?.is_reference || this.item?.is_readonly)
    },
		canSendToForge() {
      return !this.isReference && checkPermissions(['send_to_autodesk'])
		},
    openMorphableText(){
			if(this.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'Abrir Tarea Asociada'
			}
			else if(this.item.morphable_type === 'App\\Models\\Rdi' || this.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'Abrir RDI Asociada'
			}
			else if(this.item.morphable_type === 'App\\Models\\Additional' || this.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'Abrir Adicional Asociado'
			}
			return null
		},
		openMorphableIcon(){
			if(this.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'mdi-clipboard-text-outline'
			}
			else if(this.item.morphable_type === 'App\\Models\\Rdi' || this.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'mdi-file-document-multiple-outline'
			}
			else if(this.item.morphable_type === 'App\\Models\\Additional' || this.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'mdi-notebook-plus-outline'
			}
			return null
		}
	},
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutside = (e) => { if (!el.contains(e.target)) binding.value(e) }
        setTimeout(() => document.addEventListener('click', el._clickOutside), 0)
      },
      unbind(el) { document.removeEventListener('click', el._clickOutside) }
    }
  }
}
</script>

<style scoped>
.fm-ctx {
  position: fixed;
  background: var(--fm-surface2);
  border: 1px solid var(--fm-border2);
  border-radius: var(--fm-radius);
  padding: 6px;
  min-width: 180px;
  box-shadow: var(--fm-shadow-lg);
  z-index: 1000;
  animation: fm-pop 0.12s ease;
}
@keyframes fm-pop { from { transform: scale(0.94); opacity: 0; } to { transform: scale(1); opacity: 1; } }
.fm-ctx-item {
  display: flex; align-items: center; gap: 10px; width: 100%;
  background: none; border: none; color: var(--fm-text2);
  font-family: var(--fm-font); font-size: 13px;
  padding: 8px 10px; border-radius: var(--fm-radius-sm);
  cursor: pointer; text-align: left; transition: background 0.1s, color 0.1s;
}
.fm-ctx-item svg { width: 15px; height: 15px; flex-shrink: 0; }
.fm-ctx-item:hover { background: var(--fm-surface3); color: var(--fm-primary); }
.fm-ctx-item:disabled { opacity: 0.35; cursor: not-allowed; }
.fm-ctx-danger:hover { background: rgba(248,113,113,0.12); color: var(--fm-red); }
.fm-ctx-warning:hover { background: rgba(253,224,71,0.12); color: var(--fm-yellow); }
.fm-ctx-sep { height: 1px; background: var(--fm-border); margin: 4px 6px; }
</style>
